import { Carousel, Flex } from 'antd';
import VideoTool from './videoTool';
import VideoTeach from './videoTeach';
import Workflow from './workflow';
import ScenePlugin from './scenePlugin';
import AboutUs from './AboutUs';

import './index.less';
import { FaNetworkWired, FaPlug, FaServer } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const CarouselCom = [Workflow, AboutUs, ScenePlugin, VideoTool, VideoTeach];

const CarouselSection = () => {
  const navigate = useNavigate();
  return (
    <section className="home-carousel-section">
      <Carousel arrows autoplay>
        {/* <Carousel arrows> */}
        {CarouselCom.map((_Item, index) => (
          <div className="carousel-item" key={index}>
            <_Item />
          </div>
        ))}
      </Carousel>
      {/* <!-- 底部通栏 --> */}
      <Flex
        className="carousel-bottom-bar"
        align="center"
        justify="center"
        gap={12}
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/download', { replace: true })}
      >
        <span>
          <FaPlug /> 全系产品支持扣子/MCP插件定制
        </span>
        <span>
          <FaServer /> 私有化部署
        </span>
        <span>
          <FaNetworkWired /> 工作流深度集成
        </span>
      </Flex>
    </section>
  );
};

export default CarouselSection;
